import React, { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from 'react'

const STORAGE_KEY = 'k365-theme'

const readStoredTheme = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
    } catch (error) {
        return 'light'
    }
}

const KarteraThemeContext = createContext({ theme: 'light', setTheme: () => {}, toggleTheme: () => {} })

export const KarteraThemeProvider = ({ children }) => {
    const [theme, setThemeState] = useState(readStoredTheme)

    // El tema vive en <html> para que también lo hereden los portales (diálogos, menús de MUI).
    useLayoutEffect(() => {
        const root = document.documentElement
        root.dataset.kartera = ''
        root.dataset.theme = theme
        return () => {
            delete root.dataset.kartera
            delete root.dataset.theme
        }
    }, [theme])

    const setTheme = useCallback((next) => {
        const value = next === 'dark' ? 'dark' : 'light'
        setThemeState(value)
        try {
            window.localStorage.setItem(STORAGE_KEY, value)
        } catch (error) {
            // Sin almacenamiento disponible el tema solo dura la sesión.
        }
    }, [])

    const value = useMemo(() => ({
        theme,
        setTheme,
        toggleTheme: () => setTheme(theme === 'dark' ? 'light' : 'dark')
    }), [theme, setTheme])

    return <KarteraThemeContext.Provider value={value}>{children}</KarteraThemeContext.Provider>
}

export const useKarteraTheme = () => useContext(KarteraThemeContext)
